import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import * as echarts from "echarts";
import { serchSelect } from "@/mixins/index";
import { mapActions } from "vuex";
import { dataOverView, dataOverViewChat, data_compare, dataOverView_channelChat } from "@/api/overview/index.js";
import { transform } from "lodash";
export default {
  name: "overview",
  mixins: [serchSelect],
  data: function data() {
    return {
      overviewList: [{
        label: "总消耗",
        value: "cost",
        num: 0,
        Proportion: 0,
        isGoup: true
      }, {
        label: "总收入",
        value: "recharge_account_amount",
        num: 0,
        Proportion: 0,
        isGoup: true
      }, {
        label: "总roi",
        value: "roi",
        num: 0,
        Proportion: 0,
        isGoup: false
      }, {
        label: "新增用户数",
        value: "new_account_num",
        num: 0,
        Proportion: 0,
        isGoup: false
      }, {
        label: "活跃用户数",
        value: "active_account_num",
        num: 0,
        Proportion: 0,
        isGoup: false
      }, {
        label: "首日付费收入",
        value: "register_recharge_amount",
        num: 0,
        Proportion: 0,
        isGoup: false
      }, {
        label: "首日广告变现收入",
        value: "Rev-IAA",
        num: 0,
        Proportion: 0,
        isGoup: false
      }, {
        label: "总付费收入",
        value: "Rev-IAP",
        num: 0,
        Proportion: 0,
        isGoup: false
      } // {
      //   label: "总广告收入",
      //   key:"",
      //   value: 0,
      //   Proportion: "60",
      //   isGoup: false
      // }
      ],
      optionType: "pickerOptionsRadius",
      datemodelList: ['trendSearch', 'yesterdaySearch', 'coreMetricsSearch', 'coreChannelSearch'],
      value2: [],
      echarTrend: null,
      echarYesterday: null,
      echarcoreMetrics: null,
      echarcoreChannelOne: null,
      echarcoreChannelTow: null,
      trendSearchData: {
        kind: 1,
        starttime: '',
        endtime: '',
        special_product_id: ''
      },
      trendSearchDate: [],
      // 昨日数据
      yesterdaySearchData: {
        kind: 1,
        start_hour: '00',
        end_hour: '23',
        time: '',
        days: 2,
        special_product_id: ''
      },
      yesterdayList: [],
      yesterdaySelectAll: [{
        label: "充值总额",
        value: "Rev-IAP"
      }, {
        label: "登录用户数",
        value: "login_num"
      }, {
        label: "注册用户数",
        value: "register_num"
      }, {
        label: "注册充值用户数",
        value: "register_recharge_amount"
      }],
      yesterdaySelect: '',
      yesterdayData: {},
      // 核心指标
      coreMetricsSearchData: {
        kind: 1,
        starttime: '',
        endtime: '',
        special_product_id: ''
      },
      coreMetricsData: {},
      coreMetricsSelect: [],
      coreMetricsSearchDate: [],
      // 核心渠道
      coreChannelSearchData: {
        kind: 1,
        starttime: '',
        endtime: '',
        special_product_id: ''
      },
      coreChannelData: [],
      ad_channelOne: '',
      ad_channelTow: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getoverviewInit();

            case 2:
              _this.getrend();

              _this.getYesterday();

              _this.getcoreMetrics();

              _this.getcoreChannel();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {},
  methods: {
    getoverviewInit: function getoverviewInit() {
      var _this2 = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resolve, reject) {
          var date;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this2.getsearchDate();

                case 2:
                  date = _context2.sent;

                  _this2.datemodelList.forEach(function (i) {
                    _this2[i + 'Date'] = _toConsumableArray(date);
                    _this2[i + 'Data'].starttime = date[0];
                    _this2[i + 'Data'].endtime = date[0];
                    _this2[i + 'Data'].game_id = _this2.rawData.game_id;

                    if (i == 'coreMetricsSearch') {
                      _this2[i + 'Data'].special_product_id = _this2.rawData.game_show_type == 1 && _this2.isProduct ? _this2.productsList[0].id : _this2.rawData.id;
                    } else {
                      _this2[i + 'Data'].special_product_id = _this2.rawData.game_show_type == 1 && _this2.isProduct ? _this2.productsList.map(function (i) {
                        return i.id;
                      }) : _this2.rawData.id;
                    }
                  });

                  _this2.yesterdaySelect = _this2.yesterdaySelectAll[0].value;
                  _this2.coreMetricsSelect = [_this2.overviewList[0].value];
                  _this2.ad_channelOne = _this2.overviewList[0].value;
                  _this2.ad_channelTow = _this2.overviewList[0].value;
                  resolve();

                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    dateChange: function dateChange(e, type) {
      this[type + 'Data'].starttime = e[0];
      this[type + 'Data'].endtime = e[1];
    },
    // 筛选数据处理
    dataProcessing: function dataProcessing(type) {
      return _objectSpread(_objectSpread({}, this.searchData), {}, {
        special_product_id: this[type].special_product_id || this.searchData.special_product_id
      });
    },
    // 趋势
    getrend: function getrend() {
      var _this3 = this;

      if (!this.trendSearchData.special_product_id.toString()) {
        this.$message.error('请选择产品');
        return;
      }

      dataOverView(_objectSpread(_objectSpread({}, this.trendSearchData), this.dataProcessing('trendSearchData'))).then(function (res) {
        if (res.status == 200) {
          _this3.overviewList.map(function (i) {
            i.num = res.data.summary[i.value];
            i.Proportion = res.data.other[i.value];
            i.isGoup = res.data.other[i.value] > 0 ? true : false;
          });
        }
      });
      dataOverViewChat(_objectSpread(_objectSpread({}, this.trendSearchData), this.dataProcessing('trendSearchData'))).then(function (res) {
        if (res.status == 200) {
          var seriesList = [];
          var chartDom = document.getElementById("echarTrend");
          _this3.echarTrend = echarts.init(chartDom);
          var option = {
            tooltip: {
              trigger: 'axis'
            },
            // toolbox: {
            //   feature: {
            //     magicType: { show: true, type: ['line', 'bar'] },
            //     restore: { show: true },
            //     saveAsImage: { show: true }
            //   }
            // },
            legend: {
              data: ['总消耗', '总roi'],
              bottom: '0%'
            },
            grid: {
              left: "1%",
              right: "1%",
              top: "12%",
              bottom: "10%",
              containLabel: true
            },
            xAxis: [{
              type: 'category',
              data: res.data.map(function (i) {
                return i.product_name;
              }),
              axisTick: {
                show: false
              }
            }],
            yAxis: [{
              type: 'value',
              name: '总消耗',
              nameTextStyle: {
                color: '#acadb1'
              },
              axisLine: {
                show: true
              } // interval: 50,

            }, {
              type: 'value',
              name: '总roi',
              nameTextStyle: {
                color: '#acadb1'
              },
              axisLine: {
                show: true
              } // interval: 5,

            }],
            series: [{
              name: '总消耗',
              type: 'bar',
              data: res.data.map(function (i) {
                return i.cost;
              })
            }, {
              name: '总roi',
              type: 'line',
              yAxisIndex: 1,
              data: res.data.map(function (i) {
                return i.roi;
              })
            }]
          };
          option && _this3.echarTrend.setOption(option, true);
        }
      });
    },
    // 昨日数据
    getYesterday: function getYesterday() {
      var _this4 = this;

      if (!this.yesterdaySearchData.special_product_id.toString()) {
        this.$message.error('请选择产品');
        return;
      }

      this.yesterdaySearchData.time = this.$times.timestampToTime((new Date(this.$times.zeroTimeZone()).getTime() - 3600 * 1000 * 24 * 1) / 1000, 'YY-MM-DD');
      data_compare(_objectSpread(_objectSpread({}, this.yesterdaySearchData), this.dataProcessing('yesterdaySearchData'))).then(function (res) {
        if (res.status == 200) {
          // this.yesterdayData = {
          //   "2024-11-20": {
          //     "10": {
          //       "recharge_amount": 1,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "11": {
          //       "recharge_amount": 50,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "12": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "13": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "14": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "15": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "16": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "17": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "18": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "19": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "20": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "21": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "22": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "23": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "00": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "01": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "02": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "03": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "04": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "05": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "06": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "07": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "08": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "09": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     }
          //   },
          //   "2024-11-21": {
          //     "10": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "11": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "12": {
          //       "recharge_amount": 4,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "13": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "14": {
          //       "recharge_amount": 69,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "15": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "16": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "17": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "18": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "19": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "20": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "21": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "22": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "23": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "00": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "01": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "02": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "03": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "04": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "05": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "06": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "07": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "08": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     },
          //     "09": {
          //       "recharge_amount": 0,
          //       "register_num": 0,
          //       "login_num": 0,
          //       "register_recharge_amount": 0
          //     }
          //   }
          // }
          _this4.yesterdayData = _objectSpread({}, res.data);

          _this4.YesterdayChange();
        }
      });
    },
    YesterdayChange: function YesterdayChange() {
      var _this5 = this;

      this.yesterdayList = [];

      var data = _objectSpread({}, this.yesterdayData);

      var xList = [];

      for (var k in data) {
        if (!xList.length) {
          for (var j in data[k]) {
            xList.push(j);
          }
        }

        this.yesterdayList.push(_objectSpread({
          date: k
        }, data[k]));
      }

      xList.sort();
      var series = [];
      this.yesterdayList.forEach(function (i, index) {
        var dataList = [];
        xList.forEach(function (j) {
          dataList.push(i[j][_this5.yesterdaySelect]);
        });
        series.push({
          name: index == 0 ? '昨日' : '今日',
          type: 'line',
          label: {
            show: true,
            position: 'top'
          },
          data: dataList
        });
      });
      var chartDom = document.getElementById("echarYesterday");
      this.echarYesterday = echarts.init(chartDom);
      var option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['昨日', '今日'],
          bottom: '0%'
        },
        grid: {
          left: "1%",
          right: "1%",
          top: "12%",
          bottom: "10%",
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: xList,
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#999999"
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#999999"
            }
          }
        },
        series: series
      };
      option && this.echarYesterday.setOption(option, true);
    },
    // 核心指标效果
    getcoreMetrics: function getcoreMetrics() {
      var _this6 = this;

      if (!this.coreMetricsSearchData.special_product_id.toString()) {
        this.$message.error('请选择产品');
        return;
      }

      dataOverView(_objectSpread(_objectSpread({}, this.coreMetricsSearchData), this.dataProcessing('coreMetricsSearchData'))).then(function (res) {
        if (res.status == 200) {
          _this6.coreMetricsData = _objectSpread({}, res.data);

          _this6.coreMetricsChange();
        }
      });
    },
    coreMetricsChange: function coreMetricsChange() {
      var _this7 = this;

      var data = _objectSpread({}, this.coreMetricsData.data);

      var date = [];
      var legendData = [];
      var seriesList = [];

      for (var i in this.coreMetricsData.other) {
        this[i] = [];
      }

      for (var _i in data) {
        date.push(_i);

        for (var j in data[_i]) {
          this[j].push(data[_i][j]);
        }
      }

      this.coreMetricsSelect.forEach(function (item) {
        var label = _this7.overviewList.find(function (k) {
          return k.value == item;
        }).label;

        legendData.push(label);
        seriesList.push({
          name: label,
          type: 'line',
          label: {
            show: true,
            position: 'top'
          },
          data: JSON.parse(JSON.stringify(_this7[item]))
        });
      });
      var chartDom = document.getElementById("echarcoreMetrics");
      this.echarcoreMetrics = echarts.init(chartDom);
      var option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: legendData,
          bottom: '0%'
        },
        grid: {
          left: "1%",
          right: "3%",
          top: "12%",
          bottom: "10%",
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: date,
          boundaryGap: false,
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#999999"
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          show: false // interval: 50,

        },
        series: seriesList
      };
      option && this.echarcoreMetrics.setOption(option, true);
    },
    // 核心渠道效果
    getcoreChannel: function getcoreChannel(e, type) {
      var _this8 = this;

      dataOverView_channelChat(_objectSpread(_objectSpread({}, this.searchData), this.coreChannelSearchData)).then(function (res) {
        if (res.status == 200) {
          _this8.coreChannelData = _toConsumableArray(res.data);

          _this8.coreChannelChange(_this8.ad_channelOne, 'One');

          _this8.coreChannelChange(_this8.ad_channelTow, 'Tow');
        }
      });
    },
    coreChannelChange: function coreChannelChange(e, type) {
      var _this9 = this;

      var list = [];
      var total = 0;
      var data = this.overviewList.find(function (i) {
        return i.value == _this9['ad_channel' + type];
      });
      this.coreChannelData.forEach(function (i) {
        list.push({
          name: i.ad_platform,
          value: i[data.value]
        });
        total += i[data.value];
      });
      var chartDom = document.getElementById("echarcoreChannel" + type);
      this['echarcoreChannel' + type] = echarts.init(chartDom);
      var option = {
        title: {
          text: total,
          left: 'center',
          top: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          bottom: '0',
          left: 'center'
        },
        series: [{
          name: '',
          type: 'pie',
          radius: ['40%', '70%'],
          label: {
            formatter: function formatter(params) {
              if (params) {
                return "".concat(params.name, ": ").concat(params.percent === undefined ? 0 : params.percent, "%");
              }
            }
          },
          data: list
        }]
      };
      option && this['echarcoreChannel' + type].setOption(option, true);
    }
  }
};